module.exports = __webpack_public_path__ + "cement/img/bottom_tips_icon.bba70565@2x.ccc5692f.png";